export interface IDetailTripResponse {
  tripid: number
  dotNumber: string
  truckNumber: string
  type:string
  actualStart: Date
  code: string
  platE_NUMBER: string
  amountofjourneys: number
  plant: string
  facilitY_POINT: string
  avG_TIME: string
  message: string
  messagetitle: string
  color: string
  lastesT_STEP_ID: number
  lastesT_STEP_NAME: string
  checkpoinT_STEPS: Step[]
  images: Image[]
  companies: Client[]
  attributeValues: AttributeValues[]
}

export class AttributeValues {
  id: number
  nameEs: string
  nameEn: string
  selected: boolean
}

export class Client {
  name: string
  govNumber: number
  selected: boolean
}

export interface Step {
  steP_ID: number
  steP_NAME: string
  totaL_TONS: number
  averagE_TIME: string
  averagE_MINUTES: string
  averagE_MINUTES_HHMM: string
  messagetitle: string
  message: string
  color: string
}

export interface Image {
  attributeType: number
  steP_ID: number
  steP_NAME: string
  checkpoinT_ID: number
  chekpoinT_NAME: string
  imagE_URL: string
  image: string
}

export class ArribalAtPlant {
  steP_NAME: string
  averagE_TIME: string
  averagE_MINUTES: string
  averagE_MINUTES_HHMM: string
  image_truck: string[]
  image_truck_data: any[]
  image_license: string[]
  image_license_data: any
  image_truck_number: string[]
  image_truck_number_data: any
  image_dot: string[]
  image_dot_data: any
  image_company: string[]
  image_company_data: any
  image_trailer: string[]
  image_trailer_data: any
  image_side: string[]
  image_side_data: any
}
